/**
 * Reglas puras de los periodos de renovacion (sin React) - ticket #274906.
 * Viven aqui para poder probarlas sin renderizar el overlay.
 */

export const PERIOD_META = [
  { key: 'monthly',    label: 'Mensual',    months: 1,  tag: 'Flexible' },
  { key: 'bimonthly',  label: 'Bimestral',  months: 2,  tag: '2 meses' },
  { key: 'quarterly',  label: 'Trimestral', months: 3,  tag: '3 meses' },
  { key: 'semiannual', label: 'Semestral',  months: 6,  tag: '6 meses' },
  { key: 'yearly',     label: 'Anual',      months: 12, tag: 'Mejor oferta' },
];

/**
 * Precio en COP configurado por la coach para un periodo del plan.
 * NUNCA cae a USD: antes un periodo con COP=0 tomaba el valor en USD y se mostraba
 * como pesos (p. ej. Programa VIP anual salia como $1.680).
 */
export const pickCopPrice = (plan, copKey, pricingKey) =>
  Number(plan?.[copKey] || plan?.pricing?.[pricingKey]?.cop || 0);

/**
 * Periodos que muestra el overlay de plan vencido.
 * - Cliente SIN precio especial: todos los periodos con precio > 0.
 * - Cliente CON precio especial: solo el periodo de su precio especial + el anual.
 */
export const selectRenewalPeriods = (prices, { vipSpecial = 0, vipKey = 'monthly' } = {}) => {
  const priced = PERIOD_META.filter((p) => Number(prices?.[p.key]) > 0);
  if (!(Number(vipSpecial) > 0)) return priced;
  return priced.filter((p) => p.key === vipKey || p.key === 'yearly');
};

/**
 * Misma regla para /renewal (pricing_options): el backend marca con is_special la
 * opcion del periodo del precio especial; se muestra esa + la anual ('annual').
 */
export const filterForSpecialPrice = (available, opts) => {
  const hasSpecial = Object.values(opts || {}).some((o) => o && typeof o === 'object' && o.is_special);
  if (!hasSpecial) return available;
  return available.filter((m) => opts[m.optsKey]?.is_special || m.optsKey === 'annual');
};
